module.exports = __webpack_public_path__ + "img/cosco.438cea99.png";